/*
 * @Author: he.jianbo
 * @Date: 19-11-03
 * @LastEditTime: 2022-02-11 14:58:15
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\editingCenter\toutiaohao\pending\pending.js
 * @Description: 头条号渠道待审
 */

angular.module('editToutiaohaoPendingModule', ['editToutiaohaoPendingRouterModule']).controller('EditToutiaohaoPendingCtrl', [
    '$scope',
    '$state',
    'trsHttpService',
    'modalDialog',
    'trsspliceString',
    'toutiaohaoService',
    'toutConst',
    'storageListenerService',
    'editingCenterService',
    'editcenterRightsService',
    'editingMediatype',
    'messagePublishService',
    'newMediaService',
    '$filter',
    function(
        $scope,
        $state,
        trsHttpService,
        modalDialog,
        trsspliceString,
        toutiaohaoService,
        toutConst,
        storageListenerService,
        editingCenterService,
        editcenterRightsService,
        editingMediatype,
        messagePublishService,
        newMediaService,
        $filter
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                channelId: $state.params.account,
                mediaType: editingMediatype.toutiaohao,
                status_model: 1,
                isEsSearch: false, // 判断是否是经过ES检索之后
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                selectedArray: [],
                items: [],
                keyWords: '',
                account: $state.params.account,
                filterReviseItem: [],
                trench: toutConst.listenStroageKey
            };
            $scope.esparams = {}; // es检索参数
            $scope.params = {
                serviceid: 'mlf_toutiao',
                methodName: 'queryToAudit',
                CHANNELID: $state.params.account,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                timeType: 0,
                OperTimeStart: $scope.data.fromdate,
                OperTimeEnd: $scope.data.untildate,
                searchKeyWord: '',
                DocType: $scope.data.DocType,
                isPass: false
            };
        }

        /**
         * [initData description]
         * @return  {[type]}  [return description]
         */
        function initData() {
            initDropdown();
            // requestData();
            listenStorage();
            initBtnRights();
            refreshList();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData();
        };
        
        /**
         * [initData description]初始化选择类型
         * @return  {[type]}  [return description]
         */
        function initDropdown() {
            $scope.data.docTypeJsons = toutiaohaoService.initSelect();
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function(event, data) {
                    if (typeof (data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    } else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenToutiaohao(function() {
                $scope.status.isEsSearch = false;
                requestData();
                storageListenerService.removeListener('toutiaohao');
            }, $scope);
        }

        /**
         * [requestData description]数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var params = $scope.status.isEsSearch ? $scope.esparams : $scope.params;
            $scope.status.isEsSearch ? params.searchParams.PAGEINDEX = $scope.page.CURRPAGE : params.CurrPage = $scope.page.CURRPAGE;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (!$scope.status.isEsSearch) {
                    $scope.data.keyWords = '';
                }
                $scope.data.items = data.DATA;
                if ($scope.data.items.length) {
                    editingCenterService.queryVerifyDoc($scope.data.items).then(function(data) {
                        $scope.data.filterReviseItem = $scope.data.items.filter((item) => item.APPSTATUSNAME !== '待修订' && item.verifyDocIsCanOper);
                    });
                }
                newMediaService.getReviseInfo($scope.data.items);
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [initBtnRights description]
         * @return  {[type]}  [return description]
         */
        function initBtnRights() {
            editcenterRightsService.initToutiaohaoListBtn('toutiao.daishen', $scope.status.channelId).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }
        $scope.toutiaohaoEditor = function(item) {
            if (item.STATUS === '23') {
                modalDialog.alertType('宣传部送审中的稿件不能编辑', '', 'warning', false);
                return;
            }
            var docType = item.DOCTYPEID;
            var account = item.CHANNELID;
            var articleid = item.METADATAID;
            toutiaohaoService.toutiaohaoEditor(docType, account, articleid, 1);
        };

        // 按照时间搜索
        $scope.queryByDropdown = function(type, val) {
            if (type === 'DocType') {
                $scope.params.DocType = val;
            } else {
                $scope.params.OperTimeStart = $scope.data.fromdate;
                $scope.params.OperTimeEnd = $scope.data.untildate;
            }
            $scope.page.CURRPAGE = 1;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }

        };
        // 全选
        $scope.selectAll = function() {
            $scope.data.selectedArray =
                $scope.data.selectedArray.length === $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [isChecked description] 选中状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            if (!item) {
                return;
            }
            var ischecked = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].CHNLDOCID == item.CHNLDOCID) {
                    ischecked = true;
                    break;
                }
            }
            return ischecked;
        };

        /**
         * [sign description]稿件签发
         * @return {[type]} [description]
         */
        $scope.sign = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('', '每次最多签发一个稿件', 'warning', false);
                return;
            }
            if ($scope.data.selectedArray[0].STATUS === '23') {
                modalDialog.alertType('宣传部送审中的稿件不能签发', '', 'warning', false);
                return;
            }
            $scope.loadingPromise = newMediaService.sign($scope, toutConst.signOfDaishen, function(params, selectedArray) {
                params.METADATAIDS = selectedArray[0].DOC.METADATAID;
            }
            );
        };

        // 撤稿操作
        $scope.trial = function () {
            $scope.loadingPromise = newMediaService.rejection($scope, toutConst.kill);
        };

        /**
         * [directSigned description]宣传部送审
         * @return {[type]}      [description]
         */
        $scope.propagandaReview = function() {
            var reviewArray = $scope.data.selectedArray.filter(function(item) {
                return item.STATUS === '23';
            });
            if (reviewArray.length > 0) {
                modalDialog.alertType('审核中的稿件不能送审', trsspliceString.spliceString(reviewArray, 'TITLE', ','), 'warning', 'cancel');
                return;
            }
            modalDialog.inputModel('送审', '送审意见（选填）', function(content) {
                var params = {
                    serviceid: 'mlf_toutiaooper',
                    methodname: 'trialByPropagandaDepartment',
                    ToutiaohaoArticleIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                    ToutiaohaoAccountId: $state.params.account,
                    opinion: content,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function(data) {
                        modalDialog.alertType('宣传部送审成功', '', 'success', false, function() {
                            requestData();
                        });
                    },
                    function(data) {
                        modalDialog.alertType('宣传部送审失败', data.message, 'error', 'confirm');
                    }
                );
            });
        };

        /**
         * [exportDraft description]导出稿件
         *
         * @return  {[type]}  [return description]
         */
        $scope.exportDraft = function () {
            $scope.loadingPromise = newMediaService.export(
                angular.extend(
                    {
                        METADATAIDS: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    },
                    toutConst.export
                ), $scope.data.selectedArray);
        };

        /**
         * [outSending description]外发
         *
         * @return  {[type]}  [return description]
         */
        $scope.outSending = function () {
            newMediaService.outsource(
                angular.extend(
                    {
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    },
                    toutConst.outsource
                ), $scope.data.selectedArray
            );
        };

        /**
         * [draftlist description]发稿单
         * @return {[type]} [description]
         */
        $scope.draftlist = function () {
            newMediaService.draftlist($scope, toutConst.draftlistDaiShen, toutConst.draftlist);
        };

        /**
         * [pageChanged description]翻页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            $scope.loadingPromise = requestData();
        };

        /**
         * [jumpToPage description]跳转到多少页
         *
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };

        /**
         * [revise description] 修订方法
         *
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            var params = {
                DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                MediaType: '20',
            };
            $scope.loadingPromise = newMediaService.revise($scope, params);
        };

        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} item [description]
         * @return {[type]}            [description]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [distribution description]多元分发
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribution = function() {
            $scope.status.isEsSearch = false;
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')){
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                editingCenterService.distribution($scope.data.selectedArray, '20', $scope.data.selectedArray[0].DOCTYPEID, 'touTiaoDaiShenDistribute', function() {
                    $scope.data.selectedArray = [];
                    requestData();
                    // modalDialog.alertType("发稿单修改成功", "", "success", false, function() {
                    // });
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、视频', 'warning', 'confirm', function() {});
            }
        };

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        $scope.examDistributionType = function(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 7;
            }
        };

        /**
         * [isOnlyMine description] 只看我的/只看通过
         *
         * @param {[type]} key   [key description] 代表是改变通过还是我的的状态
         *
         * @return {[type]}   [return description] null
         */
        $scope.isOnlyMine = function(key) {
            $scope.page.CURRPAGE = 1;
            $scope.params[key] = !$scope.params[key];
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };
    },
]);
